'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import ForStudentsSection from './ForStudentsSection';
import ForCollegesSection from './ForCollegesSection';
import HowItWorksSection from './HowItWorksSection';
import StatsCard from './StatsCard';
import TestimonialCard from './TestimonialCard';
import FAQSection from './FAQSection';

interface Stat {
    icon: string;
    value: string;
    label: string;
}

interface Testimonial {
    name: string;
    role: string;
    institution: string;
    image: string;
    alt: string;
    quote: string;
    rating: number;
}

const HomepageInteractive = () => {
    const [isHydrated, setIsHydrated] = useState(false);
    const [currentTestimonial, setCurrentTestimonial] = useState(0);

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    const stats: Stat[] = [
        {
            icon: "👨‍🎓",
            value: "500+",
            label: "Active Students"
        },
        {
            icon: "🏫",
            value: "2",
            label: "Partner Institutions"
        },
        {
            icon: "📚",
            value: "10+",
            label: "Courses Available"
        },
        {
            icon: "🏆",
            value: "98%",
            label: "Success Rate"
        }
    ];

    const testimonials: Testimonial[] = [
        {
            name: "Sarah Johnson",
            role: "Computer Science Student",
            institution: "Stanford University",
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_1387e39bc-1765229993079.png",
            alt: "Young woman with long brown hair wearing white shirt smiling at camera in bright office setting",
            quote: "AstikLearn transformed my learning experience. The AI-powered recommendations helped me master complex algorithms in half the time I expected.",
            rating: 5
        },
        {
            name: "Dr. Michael Chen",
            role: "Dean of Academic Affairs",
            institution: "MIT",
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_183fc715d-1763301362797.png",
            alt: "Professional Asian man in navy blue suit with glasses smiling confidently in modern office",
            quote: "We've seen a 40% improvement in student engagement since implementing AstikLearn. The analytics dashboard provides invaluable insights.",
            rating: 5
        },
        {
            name: "Emily Rodriguez",
            role: "Data Science Professional",
            institution: "Google",
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_126946a46-1763294962859.png",
            alt: "Hispanic woman with short black hair in professional red blazer smiling warmly in corporate environment",
            quote: "The collaborative features are outstanding. I connected with mentors who guided me through my career transition into data science.",
            rating: 5
        }
    ];

    useEffect(() => {
        if (!isHydrated) return;

        const interval = setInterval(() => {
            setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [isHydrated, testimonials.length]);

    const handleTestimonialChange = (index: number) => {
        setCurrentTestimonial(index);
    };

    if (!isHydrated) {
        return (
            <div className="min-h-screen bg-background">
                <div className="animate-pulse">
                    <div className="h-screen bg-muted" />
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-background">

            <HeroSection />


            <ForStudentsSection />


            <ForCollegesSection />


            <HowItWorksSection />


            <section className="py-20 px-4 sm:px-6 lg:px-8 relative">
                <div className="absolute inset-0 bg-gradient-to-b from-background via-[#0F0F1A] to-background" />
                <div className="max-w-7xl mx-auto relative z-10">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl lg:text-5xl font-bold text-text-primary mb-4">
                            Proven <span className="gradient-text">Results</span>
                        </h2>
                        <p className="text-xl text-text-secondary max-w-3xl mx-auto">
                            Join thousands of successful students and institutions achieving remarkable outcomes
                        </p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {stats.map((stat, index) => (
                            <StatsCard
                                key={index}
                                icon={stat.icon}
                                value={stat.value}
                                label={stat.label}
                                delay={index * 100}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* Testimonials Section */}
            {/* <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-background via-[#0F0F1A] to-background">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl lg:text-5xl font-bold text-text-primary mb-4">
                            Trusted by <span className="gradient-text">Thousands</span>
                        </h2>
                        <p className="text-xl text-text-secondary max-w-3xl mx-auto">
                            See what students and institutions are saying about their experience with AstikLearn
                        </p>
                    </div>

                    <div className="relative">
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                            {testimonials.map((testimonial, index) => (
                                <div
                                    key={index}
                                    className={`transition-all duration-500 ${index === currentTestimonial
                                        ? 'opacity-100 scale-100' : 'opacity-40 scale-95'
                                        }`}
                                >
                                    <TestimonialCard
                                        name={testimonial.name}
                                        role={testimonial.role}
                                        institution={testimonial.institution}
                                        image={testimonial.image}
                                        alt={testimonial.alt}
                                        quote={testimonial.quote}
                                        rating={testimonial.rating}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-center gap-2 mt-8">
                            {testimonials.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleTestimonialChange(index)}
                                    className={`w-2 h-2 rounded-full transition-all focus-ring ${index === currentTestimonial
                                        ? 'bg-primary w-8' : 'bg-text-tertiary hover:bg-text-secondary'
                                        }`}
                                    aria-label={`View testimonial ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}

            {/* FAQ Section */}
            <FAQSection />




        </div>
    );
};

export default HomepageInteractive;